import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Fragment, pluralize} from '@api'
import {Menu, MenuDivider, MenuItem} from '@blueprintjs/core'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {CloudPDFEntry} from '@modules/pdf'
import {QUERY_KEY_PDF_ARTIFACTS, usePdfArtifactDropdownStore} from '@modules/pdf/serverRenderedPDF/components/PDFArtifactDropdown'
import {StoresInstance} from '@stores'
import {strings} from '@stores/StringsStore'
import {PrimaryIconButton} from 'centric-ui-components'
import {useInfiniteQuery} from 'react-query'
import {TimeAgo} from '../../../../shared/components/3rd-party'
import * as css from './PdfArtifactDropdownMenu.css'

/// region Store

export class PdfArtifactDropdownMenuStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
    this.catalog.componentStores.pdfArtifactDropdownMenu = this
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  get container() { return this.stores.cloudPDF.component }

  @action onSelectEntry = (entry: CloudPDFEntry) => () => {
    this.container.selectedPdf = entry
  }

  get cloudPDF() { return this.stores.cloudPDF}

  @computed get pdfByName() {
    const {cloudPDF: {pdfsTimestampDesc}} = this
    return _.groupBy(pdfsTimestampDesc, pdf => pdf.entry.filename)
  }

  @computed get pdfByTemplate() {
    const {cloudPDF: {pdfsTimestampDesc}} = this
    return _.groupBy(pdfsTimestampDesc, pdf => pdf.entry.template)
  }
}

export const PdfArtifactDropdownMenuStoreContext = React.createContext<PdfArtifactDropdownMenuStore>(null)
export const usePdfArtifactDropdownMenuStore = () => React.useContext(PdfArtifactDropdownMenuStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const PdfArtifactDropdownMenu = observer<MyProps>(function PdfArtifactDropdownMenu({className, ...props}) {
  const artifactDropdown = usePdfArtifactDropdownStore(),
    obsProps = useAsObservableSource({...props, artifactDropdown}),
    store = useVipLocalStore((stores) => new PdfArtifactDropdownMenuStore(stores, obsProps)),
    {pdfByName, stores: {cloudPDF: {loadPdfRecords}, users}, onSelectEntry, container: {selectedPdf}} = store,
    {
      data,
      error,
      fetchNextPage,
      hasNextPage,
      isFetching,
      isFetchingNextPage,
      status
    } = useInfiniteQuery(QUERY_KEY_PDF_ARTIFACTS, loadPdfRecords, {
      //getNextPageParam: (lastPage, pages) => lastPage.nextCursor,
    })

  useEffect(() => store.registerEffects(), [])

  const items = (data?.pages ?? []).map((p, i) => <Fragment key={i}>
    {_.orderBy(_.keys(pdfByName), k => _.maxBy(pdfByName[k], v => v.timestamp)?.timestamp, 'desc')
      .map((name, i) => <MenuItem key={i} text={name}>
        {_.orderBy(pdfByName[name], v => v.timestamp, 'desc').map(e => <MenuItem key={e.entry._id}
                                                                                 text={<div className={css.labelAndTime}>
                                                                                   {e.label}
                                                                                   <div className={css.timeago}>
                                                                                     (<TimeAgo date={e.entry.timestamp}/>)
                                                                                   </div>
                                                                                   <div className={css.buttons}>
                                                                                     <PrimaryIconButton target='_blank' href={e.url} tooltip='Open in New Tab' tooltipStyle='mui' tooltipPosition='bottom' icon='link'/>
                                                                                   </div>
                                                                                 </div>}
                                                                                 label={`${e.entry.pages} ${pluralize('page', e.entry.pages)}`}
                                                                                 icon={e.entry._id === selectedPdf?.entry?._id ? 'tick' : 'blank'}
                                                                                 onClick={onSelectEntry(e)}/>)}
      </MenuItem>)}
    {/*<MenuDivider />*/}
    {/*{p.map(e => <MenuItem key={e.entry._id}*/}
    {/*                      text={e.entry.filename ?? e.entry.s3Key}*/}
    {/*                      label={`${e.entry.pages} ${pluralize('page', e.entry.pages)}`}*/}
    {/*                      icon={e.entry._id === selectedArtifact ? 'tick' : 'blank'}*/}
    {/*                      onClick={onSelectEntry(e)}/>)}*/}
  </Fragment>).flat()
  return (<Fragment>
    <Menu className={css.menu}>
      {_.isEmpty(items) ? <MenuItem text='No Items Found' icon='blank' /> : items}
    </Menu>
  </Fragment>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/pdf/serverRenderedPDF/components/PdfArtifactDropdownMenu.tsx